export const uploadFilePath = {
  logo: "images/company_logo",
  banner: "images/company_banner",
  authLetters: "files/authorized_letters",
  tradeLicense: "files/trade_licenses",
  moa: "files/moa",
  vat: "files/vat_certificates",
  bank: "files/bank_conf_letter",
  auditedFinancial: "files/audited_financial_statement",
  supportScreenshot: "files/support_screenshot",
  userProfile: "images/profiles",
  tax: "files/tax_certificates",
  enterprise: "files/enterprise",
};
